import React, {useState} from 'react';
import cn from 'classnames';
import getLanguage, {LanguageId} from '../../../models/utils/Languages';
import IconError from '../../icon/IconError';
import DeleteIcon, {deleteIconCompanionStyles} from '../../../ui/DeleteIcon';

type Props = {
  langId: LanguageId
  className?: string
  opened: boolean
  deletable: boolean
  onDelete: (langId: LanguageId) => void,
  error?: boolean
};

export default function LanguageBlock({
  langId, className, opened = true, deletable = true, onDelete, error = false, children,
}: React.PropsWithChildren<Props>) {
  const [open, setOpen] = useState(opened || error);
  const styles = deleteIconCompanionStyles();

  return (
    <div className={cn(
      className, '-m-2 p-3 mb-4 rounded-md hover:bg-blue-table-hover',
      {'bg-blue-section': open}, styles.removableLine,
    )}>
      <div onClick={() => setOpen(!open)}
        className="font-bold cursor-pointer flex justify-between">
        <span>
          {open && <>&#9662;</>}{!open && <>&#9656;</>} {getLanguage(langId)} {!open && error &&
        <IconError className="text-red"/>}
        </span>
        {deletable &&
        <DeleteIcon title="Delete translation" onDelete={() => onDelete(langId)}
          className="mt-0.5"/>
        }
      </div>
      <div className={cn('pl-2 pt-4', {hidden: !open})}>
        {children}
      </div>
    </div>
  );
}
